
export default {
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      console.log(vm)
    })
  }
}
